// labApi.js

import { url } from "../Common/common";
import { postWithFailover } from "../Common/apiClient";

const DOCTORS_TIMEOUT_MS = 10000;
const DOCTORS_ATTEMPTS = 5;

export function getDoctors(pars, callback, onProgress) {
    console.log('getDoctors', pars);
    let formData = new FormData();
    formData.append("user_id", pars.user_id);

    if (typeof onProgress === "function") {
        postWithFailover("/getdoctors", formData, {
            timeoutMs: DOCTORS_TIMEOUT_MS,
            attemptsPerHost: DOCTORS_ATTEMPTS,
            onProgress,
        }).then((data) => {
            console.log("data getDoctors", data);
            callback(data);
        });
        return;
    }

    fetch(url + '/getdoctors', {
        method: 'POST',
        mode: 'cors', // для веба лучше cors, no-cors не позволит читать ответ
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data getDoctors', data);
        callback(data);
    })
    .catch((err) => {
        console.error('Ошибка getDoctors:', err);
    });
}

export function deleteDoctor(pars, callback) {
    console.log('deleteDoctor', pars);
    let formData = new FormData();
    formData.append("doctor_id", pars.doctor_id);

    fetch(url + '/deletedoctor', {
        method: 'POST',
        mode: 'cors',
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        console.log('data deleteDoctor', data);
        callback(data);
    })
    .catch(err => console.error('Ошибка deleteDoctor:', err));
}

export function getTechnics(pars, callback) {
    // console.log('getTechnics')
    let formData = new FormData();
    formData.append("email", '');
    formData.append("user_id", pars.user_id);
    
    fetch(url + '/gettechnics', {
        method: 'POST',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log(' data getTechnics', data)
        return callback(data)
    });
}

export function newDoctor(pars, callback) {
    console.log('newDoctor', pars);
    let formData = new FormData();
    formData.append("email", pars.email);
    formData.append("password", pars.password);
    formData.append("name", pars.name);
    formData.append("surname", pars.surname);
    formData.append("country", pars.country);
    formData.append("region", pars.region);
    formData.append("company", pars.company);
    formData.append("inn", pars.inn || '');
    formData.append("kpp", pars.kpp || '');
    formData.append("user_id", pars.user_id);

    fetch(url + '/newdoctor', {
        method: 'POST',
        mode: 'cors',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data newDoctor', data);
        callback(data);
    })
    .catch((err) => {
        console.error('Ошибка newDoctor:', err);
    });
}

export function uploadPhoto(pars, callback) {
    console.log('uploadPhoto', pars);
    let formData = new FormData();
    formData.append("avatar", pars.photo);
    formData.append("user_id", pars.user_id);

    fetch(url + '/photo', {
        method: 'POST',
        mode: 'cors',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data uploadPhoto', data);
        callback(data);
    })
    .catch((err) => {
        console.error('Ошибка uploadPhoto:', err);
    });
}

export function getAllDoctors(callback) {
    console.log('getAllDoctors');
    let formData = new FormData();
    
    fetch(url + '/getalldoctors', {
        method: 'POST',
        mode: 'cors',
        body: formData
    })
    .then((response) => response.json())
    .then((data) => {
        console.log('data getAllDoctors', data);
        callback(data);
    })
    .catch((err) => {
        console.error('Ошибка getAllDoctors:', err);
    });
}

export function saveDoctor(pars, callback) {
    let formData = new FormData();
    // console.log('ok')
    Object.entries(pars).forEach(([key, value]) => {
        formData.append(key, value);
    });
    // console.log('ok')

    fetch(url + '/savedoctor', {
        method: 'POST',
        mode: 'no-cors',
        body: formData
    })
    .then((response) => {
        // console.log('ok')
        return response.json();
    })
    .then((data) => {
        // console.log('data', data)
        return callback(data)
    })
    .catch((err) => {
        console.error('Ошибка saveDoctor:', err);
    });
}